import { bodyBgWidth } from './BodyBgStore.js';

export const updateBodyBgWidth = (value) => bodyBgWidth.update(oldValue => value);
